import React, { useEffect, useState } from 'react';
import { Alert } from '@mui/material';
import { useSelector } from 'react-redux';

const Notification = ({ notification, notificationsContext }) => {
  const isDrawerOpen = useSelector((state) => state.ui.persisted.isDrawerOpen);
  // Timeout for notification duration in seconds
  const timeout = 5;

  const [scrollPosition, setScrollPosition] = useState(0);
  const yOffset = 56;

  const handleScroll = () => {
    const position = window.scrollY;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    // Notification disappears after timeout duration
    setTimeout(() => {
      notificationsContext.removeNotification(notification.id);
    }, timeout * 1000);
  }, []);

  return (
    <Alert
      sx={[
        {
          marginBottom: '5px',
          '&:last-child': {
            marginBottom: 0,
          },
        },
        // fixed position
        scrollPosition >= yOffset && {
          zIndex: 120,
          position: 'fixed',
          width: { xs: `calc(100% - 16px)`, sm: isDrawerOpen ? `calc(100% - 265px)` : `calc(100% - 100px)` },
      }]}
      variant="filled"
      severity={notification.type}
      onClose={() => notificationsContext.removeNotification(notification.id)}
    >
      {notification.message}
    </Alert>
  );
};

export default Notification;
